document.addEventListener('DOMContentLoaded', () => {
  const button = document.getElementsByClassName('back-to-top');

  if(button.length > 0) {
    button[0].addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
});
